import en from "./simple/en.json";
import zh from "./simple/zh.json";

export default { en, zh };
